module.exports = __webpack_public_path__ + "img/music.dab895d8.png";